import { compress, compressToBase64, decompress, decompressFromBase64 } from '@msdk/definitions'

/**
 * attaches compression functions to the global window object
 * so they can be used from the dev tools console to debug compressed
 * storage of url context.
 */
export function attachCompressionToWindow() {
  const windowObj = window as any
  windowObj.Compression = {
    compressToBase64,
    decompressFromBase64,
    compress,
    decompress,
  }
}
